export default {
  name: 'LkButton',
  emits: ['onClick'],
  props: {
    isSecondary: {
      type: Boolean,   // default value is false
      default: false
    }
  },
  methods: {
    onClick () {
      this.$emit('onClick')
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/entities/buttons/regular-button/script.js